<template>
  <fieldset v-if="!hasUsername">
    <div class="bv-no-focus-ring" tabindex="-1" role="group">
      <label class="form__label form__label--sub comments__public-username"
        >It's your first time posting! Set your public username.</label
      >
      <!-- eslint-disable vue/no-mutating-props -->
      <InputWithContextMenu
        v-model="model.username"
        class="form-control"
        placeholder="Enter username here"
        type="text"
        :class="validation.stateClass('username')"
      />
      <!-- eslint-enable vue/no-mutating-props -->
      <FormError :errors="validation.errors" field="username" />
    </div>
  </fieldset>
  <p v-if="!hasUsername" class="comments__policy">
    Shortform appreciates and encourages reader comments. Shared perspectives
    and expertise, questions, and suggestions of further avenues to explore add
    value for everyone. Please be civil, constructive, and consistent with our
    <a class="comments__policy-link" href="/terms">Terms of Service</a>.
  </p>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import FormError from '@/components/ui/FormError.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import { auth } from '@/services/auth'
import type { ValidationState } from '@/helpers/form'

const props = defineProps<{
  model: any
  validation: ValidationState
}>()

const hasUsername = ref(true)

onBeforeMount(() => {
  /* eslint-disable vue/no-mutating-props */
  props.model.username = auth.getUsername()
  /* eslint-enable vue/no-mutating-props */
  if (!props.model.username) {
    hasUsername.value = false
  }
})

function saved(): void {
  const username = auth.getUsername()
  if (username) {
    hasUsername.value = true
  }
}

defineExpose({
  saved,
})
</script>

<style lang="scss" scoped>
.comments {
  &__policy {
    color: $c-black-3;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  &__policy-link {
    color: $c-blue-2;
    text-decoration: none;
    @include hover {
      text-decoration: underline;
    }
  }
}

.night-mode {
  .comments {
    &__policy {
      color: $c-black-6;
    }
    &__policy-link {
      color: $c-blue-5;
    }
  }
}
</style>
